import TeamManagment from './TeamManagment.Container';

export default TeamManagment;
